module.exports = __webpack_public_path__ + "img/hong_kong.42a6b29.webp";